import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Automation Free Limit Modal (Free edition with automation limits).
 */
export function isEligibleForAutomationFreeLimitModal(
	context: EditionAwarenessContextType,
): boolean {
	const { isInCollection, edition, automationFreeLimitStatus, product, canUpgrade } = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['free']) &&
		isProductOneOf(product, ['jira']) &&
		canUpgrade &&
		automationFreeLimitStatus,
	);
}
